export const inspectionData = [
  {
    key: "Kitchen",
    itemCardTitle: "Kitchen",
    items: [
      {
        key: "1",
        itemTitle: "Refrigerator",
        isDone: false,
        isFollowUp: false,
      },
      {
        key: "2",
        itemTitle: "Sink",
        isDone: false,
        isFollowUp: false,
      },
      {
        key: "3",
        itemTitle: "Oven/Stove",
        isDone: false,
        isFollowUp: false,
      },
    ],
  },
  {
    key: "Living Room",
    itemCardTitle: "Living Room",
    items: [
      {
        key: "4",
        itemTitle: "Windows",
        isDone: false,
        isFollowUp: false,
      },
      {
        key: "5",
        itemTitle: "Doors",
        isDone: false,
        isFollowUp: false,
      },
    ],
  },
  {
    key: "Bedroom 1",
    itemCardTitle: "Bedroom 1",
    items: [
      {
        key: "6",
        itemTitle: "Windows",
        isDone: false,
        isFollowUp: false,
      },
      {
        key: "7",
        itemTitle: "Doors",
        isDone: false,
        isFollowUp: false,
      },
    ],
  },
  {
    key: "Bedroom 2",
    itemCardTitle: "Bedroom 2",
    items: [],
  },
];
